module.exports = __webpack_public_path__ + "static/media/Olivia Kitchen (2).4908f387.jpg";